import { render, staticRenderFns } from "./ResolutionSwitcher.vue?vue&type=template&id=0f6ead08&scoped=true&"
import script from "./ResolutionSwitcher.vue?vue&type=script&lang=js&"
export * from "./ResolutionSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionSwitcher.vue?vue&type=style&index=0&id=0f6ead08&lang=scss&scoped=true&"
import style1 from "./ResolutionSwitcher.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ead08",
  null
  
)

export default component.exports